import { render, staticRenderFns } from "./LocalsCreationModal.vue?vue&type=template&id=536194a2&scoped=true"
import script from "./LocalsCreationModal.vue?vue&type=script&lang=js"
export * from "./LocalsCreationModal.vue?vue&type=script&lang=js"
import style0 from "./LocalsCreationModal.vue?vue&type=style&index=0&id=536194a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536194a2",
  null
  
)

export default component.exports